import api from './api';

export function getMyPermissions() {
  return api.get('/permissions/me');
}
